import { Box, Flex, Textarea, FormControl, FormLabel } from '@chakra-ui/react';
import { Week } from '../../lib/types/programEdit';
import StrongTextarea from '../common/StrongTextarea';

type WeekDetailProps = {
  weekIndex: number;
  week: Week;
  updateWeek: (weekIndex: number, updatedWeek: Week) => void;
};

export const WeekDetail = ({ weekIndex, week, updateWeek }: WeekDetailProps) => {
  const updateWeekDetail = (key: keyof Week, value: any) => {
    const updatedWeek = { ...week, [key]: value };
    updateWeek(weekIndex, updatedWeek);
  };

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = event.target;
    updateWeekDetail(name as keyof Week, value);
  };

  return (
    <Flex mb={4} mt="25px">
      <Box w="50%">
        <FormControl>
          <FormLabel>Description</FormLabel>
          <StrongTextarea
            name="description"
            value={week.description}
            onChange={handleChange}
            resize="none"
          />
        </FormControl>
      </Box>
    </Flex>
  );
};